import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import AdminNavbar from "../AdminNavbar/AdminNavbar";
import { database, ref, get } from "../../../firebase";

const AdminCallClose = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [callCloseData, setCallCloseData] = useState({
    UserId: localStorage.getItem("UserID") || "",
    OutletId: "",
    Call_Id: "",
    SupportEnggCallId: id,
    AdminToSupportEngg_id: "",
    SupportEnggName: "",
    CallCloseStatus: "",
  });
  const [firebaseToken, setFirebaseToken] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_API}/SupportEngg/${id}`
        );

        if (response.data.success && response.data.data) {
          const {
            OutletId,
            Call_Status,
            UserId,
            Call_Id,
            AdminToSupportEngg_id,
            SupportEnggName,
            SupportEnggMobileNo,
            howtosolveinformation,
          } = response.data.data;

          setCallCloseData({
            ...callCloseData,
            OutletId: OutletId?._id || "",
            SupportEnggName: UserId?.User_Name || "",
            Outlet_name: OutletId?.Outlet_name || "",
            AdminToSupportEngg_id: AdminToSupportEngg_id?._id || "",
            Call_Id: Call_Id?._id || "",
            CallCloseStatus: Call_Status || "",
            SupportEnggMobileNo,
            howtosolveinformation,
          });

          
          await fetchFirebaseUsers(Call_Id.UserId);
        } else {
          console.error("Data not found:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_API}/CallCloseStatus`,
        callCloseData
      );
      console.log("POST request successful:", response.data);
      setCallCloseData({
        ...callCloseData,
        SupportEnggName: "",
        CallCloseStatus: "",
        AdminToSupportEngg_id: ""
      });
      navigate("/AdminCallCloseStatus");
      await SendNotificationProcess();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setCallCloseData({
      ...callCloseData,
      [name]: value,
    });
  };

  const fetchFirebaseUsers = async (userId) => {
    try {
      const usersRef = ref(database, 'users');
      const snapshot = await get(usersRef);

      if (snapshot.exists()) {
        const users = snapshot.val();
        const selectedUser = Object.values(users).find(user => user.UserId === userId);
        if (selectedUser) {
          console.log("Selected Firebase User:", selectedUser);
          setFirebaseToken(selectedUser.firebaseToken);
        } else {
          console.log("Selected user not found in Firebase.");
        }
      } else {
        console.log("No users found.");
      }
    } catch (error) {
      console.error("Error fetching users from Firebase:", error);
    }
  };

  const SendNotificationProcess = async () => {
    try {
      if (!firebaseToken) {
        console.error("Firebase token is not set");
        return;
      }

      if (!callCloseData.OutletId || !callCloseData.Call_Id) {
        console.error("Call data is missing");
        return;
      }

      const imageURL = "/static/media/NavbarLogo.7aff387d8291bb227a01.png";

     
      const response = await axios.post(`${process.env.REACT_APP_SERVER_API}/sendnotification`, {
        token: firebaseToken,
        title: `Restaurant: ${callCloseData.Outlet_name} Call Closed`,
        body: `Support Engg: ${callCloseData.SupportEnggName} Mobile No: ${callCloseData.SupportEnggMobileNo} solved the problem: ${callCloseData.howtosolveinformation}`,
        image: imageURL
      });

      console.log("Notification sent successfully:", response.data);
    } catch (error) {
      console.error("Failed to send notification:", error);
    }
  };


  return (
    <>
      <AdminNavbar />
      <div className="container">
        <div className="row d-flex justify-content-center">
          <div className="col-md-4 shadow-lg p-3 mb-5 bg-body rounded">
            <form onSubmit={handleSubmit}>
              <div className="form-floating mb-3">
                <select
                  className="form-select"
                  name="CallCloseStatus"
                  value={callCloseData.CallCloseStatus}
                  onChange={handleOnChange}
                  aria-label="Select Call Status"
                  required
                >
                  <option value="">Select Status</option>
                  <option value="Call Close">Call Close</option>
                </select>
                <label htmlFor="CallCloseStatus">Select Call Status</label>
              </div>
              <div className="modal-footer d-flex justify-content-center">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminCallClose;
